module.exports = __webpack_public_path__ + "img/53_35.a6d82ad9.png";